<template>
    <md-icon class="md-icon-image" v-once>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <g>
                <path fill="#343A40" d="M401.53,219.47H292.36V110.3A24.29,24.29,0,0,0,268.06,86H243.77a24.29,24.29,0,0,0-24.3,24.3V219.55H110.3A24.29,24.29,0,0,0,86,243.85v24.3a24.29,24.29,0,0,0,24.3,24.3H219.55V401.7a24.29,24.29,0,0,0,24.3,24.3h24.3a24.29,24.29,0,0,0,24.3-24.3V292.36H401.7a24.29,24.29,0,0,0,24.3-24.3V243.77A24.54,24.54,0,0,0,401.53,219.47Z"/>
            </g>
        </svg>
    </md-icon>
</template>

<script>
    import MdIcon from "../../../components/MdIcon/MdIcon";

    export default {
        name: 'GdAddItemIcon',
        components: {
            MdIcon
        }
    }
</script>
